import { Alert, Flex } from 'antd';
import { ErrorListDisplay } from 'components/ErrorDisplay';
import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';
import { UseErrorListReturn } from 'lib/utils/useErrorList';
import { PatientListProgressTable } from './components/PatientListProgressTable';
import { ProgressTableRow } from './types';

interface ProgressStateProps {
  assessmentTypeToSend: AssessmentType | null;
  progressRows: ProgressTableRow[];
  isSentComplete: boolean;
  errorList: UseErrorListReturn;
  successfulCount: number;
  failedCount: number;
}

export function ProgressState(props: ProgressStateProps) {
  return (
    <Flex vertical gap="middle" style={{ marginTop: 16 }}>
      <p>
        {!props.isSentComplete ? (
          <strong>Sending {props.assessmentTypeToSend} assessments...</strong>
        ) : (
          <strong>Sent assessments</strong>
        )}
      </p>

      <PatientListProgressTable rows={props.progressRows} showStatus={true} />

      {props.isSentComplete && (
        <Alert
          type={props.errorList.hasErrors ? 'warning' : 'success'}
          message={(() => {
            if (props.errorList.hasErrors) {
              return `Bulk sending completed with some errors. Successful: ${props.successfulCount}, Failed: ${props.failedCount}.`;
            }
            return `All assessments successfully sent! Successful: ${props.successfulCount}, Failed: ${props.failedCount}.`;
          })()}
        />
      )}

      {props.isSentComplete && props.errorList.hasErrors && (
        <ErrorListDisplay errorList={props.errorList} closeable />
      )}
    </Flex>
  );
}
